<template>
  <section class="section-body has-background-dark">
    <div class="card box">
      <div class="is-flex">
        <div class="card-image">
          <img :src="logo" alt="Placeholder image"/>
        </div>
        <div style="width: 100%;"><span class="tag is-danger is-pulled-right">CARFAX</span></div>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title is-4">Carfax</p>
            <p class="subtitle is-6">session notification</p>
          </div>
        </div>

        <div class="content has-text-left">
          <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
          <div v-if="!hasServerReturnedErrorMessage" class="columns is-multiline box has-background-info">
            <div class="column is-1">
              <i class="fal fa-info-circle fa-2x has-text-white"></i>
            </div>
            <div class="column has-text-white">
              <p class="is-size-6">Please wait while we process your request for CARFAX session activation.</p>
              <b-progress size="is-small" type="is-success"></b-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import carfaxService from '@/services/carfaxService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

export default {
  name: 'CarfaxCallback',
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  inject: {
    $validator: '$validator'
  },
  data () {
    return {
      requestAttempted: false,
      isLoading: false,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      logo: require('@/assets/eag_logo.png')
    }
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasServerReturnedErrorMessage: function () {
      if ((this.requestAttempted && this.serverErrorMessage) || (this.requestAttempted && this.serverErrors && this.serverErrors.length > 0)) {
        return true
      }
      return false
    }
  },
  methods: {
    getAuthenticationToken: function () {
      const code = this.code
      const state = this.state
      const that = this
      this.isSaving = true
      this.requestAttempted = true
      this.serverErrorMessage = ''
      this.serverErrors = []

      carfaxService.getUserAuthenticationToken(code, state).then(response => {
        that.isSaving = false
        if (response.errors) {
          that.serverErrors = response.errors
        } else {
          that.$router.push({ name: 'CarfaxCallbackCompleted' })
        }
      }).catch((error) => {
        if (error) {
          if (error.message) {
            that.serverErrorMessage = error.message
          } else {
            that.serverErrorMessage = error
          }
        }
        that.isSaving = false
      })
    }
  },
  created () {
    this.$emit('is-home', false)
    this.$emit('show-header', false)
    this.$emit('show-footer', false)
  },
  mounted () {
    this.getAuthenticationToken()
  }
}
</script>
<style scoped>
  .card {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 560px;
  }

  .card-image {
    width: 282px;
  }

  .section-body {
    width: 100%;
    height: 100%;
  }
</style>
